module.exports = __webpack_public_path__ + "static/media/portfolio1 (30).36a05569.jpeg";